import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "registration-page-header" }, null, -1)
const _hoisted_2 = { class: "registration-page" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "registration-page-background-noise" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "skyline-logo" }, null, -1)

import { onMounted, ref } from 'vue';
import { UserRole } from '@/models/UserRoles';
import { useRouter } from 'vue-router';
import Routes, { RouteNames } from '../router/Routes';
import { useGlobalStore } from '../store/globalStore';
import { storeToRefs } from 'pinia';
import { User } from '../models/User';
import RegistrationComponent from '../components/login/RegistrationComponent.vue';
import { ApiError } from '../api/plugins/ApiRetry';

interface Payload {
  role: UserRole;
  firstName: string;
  lastName: string;
  code: string;
}

// const registerUser = async (payload: any) => {

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCreationPage',
  setup(__props) {

const router = useRouter();
const store = useGlobalStore();
const errorMessage = ref<string>('');

const { firebaseUser } = storeToRefs(useGlobalStore());

onMounted(() => {
  store.pageViewEvent(RouteNames.PROFILE_CREATION);
});

const registerUser = async (payload: Payload) => {
  if (!firebaseUser.value?.uid) {
    errorMessage.value = 'User not logged in';
    return;
  }
  const user: User = {
    uid: firebaseUser.value?.uid,
    firstName: payload.firstName,
    lastName: payload.lastName,
    role: payload.role,
    email: firebaseUser.value?.email || '',
    organizationId: '',
    courseId: '',
    classId: ''
  };

  store.registerUserEvent(
    firebaseUser.value.uid,
    payload.role,
    payload.code,
    'attempt'
  );

  const response = await store.createUserFullyQualified(user, payload.code);
  const responseAsError = response as ApiError;
  const responseAsUser = response as User;
  if (responseAsError.message) {
    errorMessage.value = responseAsError.message;
    store.registerUserEvent(
      firebaseUser.value.uid,
      payload.role,
      payload.code,
      'failure'
    );
    return;
  }

  store.registerUserEvent(
    firebaseUser.value.uid,
    payload.role,
    payload.code,
    'success'
  );

  await store.fetchUser(responseAsUser.uid || '');
  switch (responseAsUser.role) {
    case UserRole.STUDENT:
      router.push(Routes.STUDENT);
      break;
    case UserRole.INSTRUCTOR:
      router.push(Routes.INSTRUCTOR);
      break;
    case UserRole.ADMIN:
      router.push(Routes.ADMIN);
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(RegistrationComponent, {
        onRegister: registerUser,
        error: errorMessage.value,
        class: "registration-component"
      }, null, 8, ["error"])
    ])
  ], 64))
}
}

})